var exports = {
  "n": "swatch__OatTqe",
};

module.exports = exports;
